import { Component, Input, EventEmitter, Output }  from '@angular/core';
import { LeoBox, DataTable, Modal } from '../../../ui-helper';
import { StringDatePipe } from '../../../ui-helper/string-date.pipe';
import { Spinner } from '../../../ui-helper'

import * as model from "../../../models";
import * as ui from "../../../models/ui";
import { Observable } from "rxjs";
import { Store } from "@ngrx/store";
import { TicketQuotaState } from "../../../reducers/ticket-quota.reducer"
import { TicketQuotaActions, MessageActions, EventActions } from "../../../actions"
import { AppState, MessageState } from "../../../reducers"
import { TicketQuota } from "./ticket-quota"
import { TicketQuotaForm } from "./ticket-quota-form"
import { TicketQuotaMessageEditor } from "./ticket-quota-message-editor"
import { DataTableObject, DataTableRow } from "../../../ui-helper/data-table"
import { EventApi, MerchantApi } from '../../../services/webservice'


@Component({
	selector: 'ticket-quota-collection',
	templateUrl: "./ticket-quota-collection.html"
})
export class TicketQuotaCollection {

	protected ticketQuotaToBeDeleted: TicketQuota;
	protected ticketQuotaCollection$: Observable<model.TicketQuota[]>;
	protected ticketQuotaMessages$: Observable<model.TicketQuotaMessage[]>;
	protected categories$: Observable<model.Category[]>;
	protected ticketQuotaMessageEditorActions$: Observable<ui.TicketQuotaMessageEditorAction[]>;
	protected displayTicketQuotaMessages$: Observable<ui.DisplayTicketQuotaMessage[]>;
	protected tableData$: Observable<DataTableObject>;
	protected selectedTicketQuota$: Observable<model.TicketQuota>;
	protected ticketQuotaInEdit$: Observable<model.TicketQuota>;
	protected ticketQuotaStatusForDisplay$: Observable<model.TicketQuotaStatus[]>;
	protected bookingOffices$: Observable<model.BookingOffice[]>;
	protected showSpinner: boolean = false;
	protected minDisplayTimeMs = 200;

	private displayTicketQuotaForm: boolean = false
	private displayTicketQuotaActionButtons: boolean = true
	private displayTicketQuotaMessageButtons: boolean = true
	private displaySimpleTicketQuotaMessageEditor: boolean = true
	private enableVisualTicketQuotaToggle: boolean
	private loadedEvent: model.Event
	private selectedSeatingplan: model.Seatingplan
	private selectedTicketQuotaStorageId: string
	private enableVisualTicketQuotaTooltipMsg: string = ""

	@Input()
	set ticketQuotasUrl(ticketQuotasUrl: string) {
		if (ticketQuotasUrl) {
			this.store.dispatch(this.ticketQuotaActions.loadCollection(ticketQuotasUrl));
		}
	}


	constructor(
		private messageActions: MessageActions,
		private ticketQuotaActions: TicketQuotaActions,
		private eventActions: EventActions,
		private store: Store<AppState>,
		private eventApi: EventApi,
		private merchantApi: MerchantApi,
	) { }

	ngOnInit() {
		this.bookingOffices$ = this.loadBookingOffices();
		this.selectedTicketQuota$ = this.store.select("eventServerState", "ticketQuotas", "selectedTicketQuota")
		this.ticketQuotaInEdit$ = this.store.select("eventServerState", "ticketQuotas", "ticketQuotaInEdit")
		this.ticketQuotaCollection$ = this.store.select("eventServerState", "ticketQuotas", "ticketQuotaCollection")
		this.ticketQuotaMessages$ = this.store.select("eventServerState", "ticketQuotas", "ticketQuotaMessages")
		this.categories$ = this.store.select("eventServerState", "categories", "categories")

		this.ticketQuotaMessageEditorActions$ = Observable.combineLatest(this.selectedTicketQuota$, this.categories$, (ticketQuota, categories) => {
			if (ticketQuota && categories.length > 0) return this.createTicketQuotaMessageEditor(ticketQuota.ticketQuotaStatus, categories)
			return []
		})

		this.displayTicketQuotaMessages$ = this.ticketQuotaMessages$.map(this.createDisplayTicketQuotaMessages);
		this.tableData$ = Observable.combineLatest(this.categories$, this.displayTicketQuotaMessages$, this.selectedTicketQuota$, this.buildTableData)

		this.selectedTicketQuota$.subscribe((ticketQuota: model.TicketQuota) => {
			if (ticketQuota) {
				this.selectedTicketQuotaStorageId = ticketQuota.storageId
			}
		})

		this.store.select("eventServerState", "event", "currentEvent").subscribe((event: model.Event) => {
			this.loadedEvent = event;
			if (event) {
				this.displaySimpleTicketQuotaMessageEditor = !this.loadedEvent.userSetHasVisualQuota;
			}
		})

		this.checkIfToggleMessageEditorEnabled()

		this.ticketQuotaStatusForDisplay$ = Observable.combineLatest(this.selectedTicketQuota$, this.categories$, (ticketQuota, categories) => {
			if (ticketQuota && categories.length > 0) return this.getCreateTicketQuotaStatusForDisplay(ticketQuota.ticketQuotaStatus, categories)
			return []
		})
	}

	ngOnDestroy() {
		// TODO this doesnt work?
		// window.removeEventListener("storage")
	}

	deleteQuotaYes() {
		this.store.dispatch(this.ticketQuotaActions.deleteTicketQuota(this.ticketQuotaToBeDeleted))
		this.ticketQuotaToBeDeleted = null;
	}

	deleteQuotaNo() {
		this.ticketQuotaToBeDeleted = null;
	}

	buildTableData = (categories: model.Category[], displayTicketQuotaMessages: ui.DisplayTicketQuotaMessage[],
		selectedTicketQuota: model.TicketQuota) => {

		if (displayTicketQuotaMessages.length === 0) return null;
		const header = ["Datum", "Kommentar", ...categories.map(cat => cat.name)]
		const rows = [];
		const footer = ["", "", ...categories.map(cat => "")];
		for (let displayTicketQuotaMessage of displayTicketQuotaMessages) {
			if (Object.keys(displayTicketQuotaMessage.actions).length) {

				const rowData =
					[new StringDatePipe().transform(displayTicketQuotaMessage.date, null),
					displayTicketQuotaMessage.comment,
					...categories.map(cat => "")
					]
				for (const categoryUUID in displayTicketQuotaMessage.actions) {
					const category = categories.find(cat => cat.uuid === categoryUUID);
					const index = categories.indexOf(category) + 2;
					rowData[index] = displayTicketQuotaMessage.actions[categoryUUID] + ""
				}
				rows.push({ rowHover: displayTicketQuotaMessage.comment, rowData: rowData })
			}
		}
		if (selectedTicketQuota) {
			for (let status of selectedTicketQuota.ticketQuotaStatus) {
				const category = categories.find(cat => cat.uuid === status.category.uuid);
				const index = categories.indexOf(category) + 2;
				footer[index] = status.totalTickets + "";
			}
		}
		return {
			header: header,
			rows: rows,
			footer: footer
		}

	}

	selectTicketQuota(selectedTicketQuota: model.TicketQuota) {
		if (selectedTicketQuota) {
			this.hideTicketQuotaForm()
			this.store.dispatch(this.ticketQuotaActions.setSelectedTicketQuota(selectedTicketQuota))
		}
	}

	newTicketQuota() {
		this.showTicketQuotaForm()
		let newTicketQuota: model.TicketQuota = {
			name: ""
		}
		this.store.dispatch(this.ticketQuotaActions.setTicketQuotaInEdit(newTicketQuota))
	}

	editTicketQuota(ticketQuotaToUpdate: model.TicketQuota) {
		this.showTicketQuotaForm()
		this.store.dispatch(this.ticketQuotaActions.setTicketQuotaInEdit(ticketQuotaToUpdate))
	}

	createOrUpdateTicketQuota(ticketQuota: model.TicketQuota) {
		this.hideTicketQuotaForm()
		if (ticketQuota._links) this.store.dispatch(this.ticketQuotaActions.updateTicketQuota(ticketQuota))
		else this.store.dispatch(this.ticketQuotaActions.createTicketQuota(ticketQuota))
	}

	deleteTicketQuota(ticketQuotaToBeDeleted: TicketQuota) {
		this.ticketQuotaToBeDeleted = ticketQuotaToBeDeleted;
	}

	postTicketQuotaMessage(ticketQuotaMessage: model.TicketQuotaMessage) {
		this.store.dispatch(this.ticketQuotaActions.postTicketQuotaMessage(ticketQuotaMessage))
	}

	saveBookingOffices(bookingOfficeUUIDs: string[]) {
		let ticketQuota: model.TicketQuota;
		this.selectedTicketQuota$.take(1).subscribe(
			quota => ticketQuota = quota
		)

		const updateObj = Object.assign({}, ticketQuota, {
			allowedBookingOfficeUUIDs: bookingOfficeUUIDs
		});

		this.store.dispatch(this.ticketQuotaActions.updateTicketQuota(updateObj))
	}

	showSaveTicketQuotaErrorMsg() {
		this.store.dispatch(
			this.messageActions.displayMessage("Das Kontingent konnte nicht gespeichert werden. Bitte korrigieren Sie die rot umrandeten Felder.", "error")
		)
	}

	private createTicketQuotaMessageEditor(ticketQuotaStatusObjects: model.TicketQuotaStatus[],
		categories: model.Category[]): ui.TicketQuotaMessageEditorAction[] {

		let ticketQuotaMessageEditorActions = this.createEditorActions(ticketQuotaStatusObjects)
		let presentCategoryIds = ticketQuotaStatusObjects.map(ticketQuotaStatus => ticketQuotaStatus.category.uuid)
		return ticketQuotaMessageEditorActions.concat(this.createEditorActionsForNonPresentCategories(presentCategoryIds, categories))
	}

	private createEditorActions(ticketQuotaStatusObjects: model.TicketQuotaStatus[]): ui.TicketQuotaMessageEditorAction[] {
		return ticketQuotaStatusObjects.map(status => {
			return {
				totalNumberOfTickets: status.totalTickets,
				availableNumberOfTickets: status.availableTickets,
				category: status.category
			}
		})
	}

	private createEditorActionsForNonPresentCategories(presentCategoryIds: string[], categories: model.Category[]): ui.TicketQuotaMessageEditorAction[] {
		const missingCategories = categories.filter(cat => presentCategoryIds.indexOf(cat.uuid) === -1)
		return missingCategories.map(cat => {
			return {
				totalNumberOfTickets: 0,
				availableNumberOfTickets: 0,
				category: cat
			}
		})
	}

	private getCreateTicketQuotaStatusForDisplay(ticketQuotaStatusObjects: model.TicketQuotaStatus[], categories: model.Category[]) {
		let presentCategoryIds = ticketQuotaStatusObjects.map(ticketQuotaStatus => ticketQuotaStatus.category.uuid)
		const missingCategories = categories.filter(cat => presentCategoryIds.indexOf(cat.uuid) === -1)
		let ticketQuotaStatusForMissingCategories = missingCategories.map(cat => {
			return {
				totalTickets: 0,
				availableTickets: 0,
				category: cat,
				seatState: {},
				freeSeatingState: {}
			}
		})
		return ticketQuotaStatusObjects.concat(ticketQuotaStatusForMissingCategories)
	}

	private createDisplayTicketQuotaMessages = (ticketQuotaMessages: model.TicketQuotaMessage[]): ui.DisplayTicketQuotaMessage[] => {
		return ticketQuotaMessages.map(tqm => ui.DisplayTicketQuotaMessage.fromTQM(tqm));
	}

	private showTicketQuotaForm() {
		this.displayTicketQuotaForm = true
		this.displayTicketQuotaActionButtons = false
		this.displayTicketQuotaMessageButtons = false
	}

	private hideTicketQuotaForm() {
		this.displayTicketQuotaForm = false
		this.displayTicketQuotaActionButtons = true
		this.displayTicketQuotaMessageButtons = true
	}

	private checkIfToggleMessageEditorEnabled() {
		this.ticketQuotaCollection$.subscribe(ticketQuotaCollection => {
			this.enableVisualTicketQuotaToggle = true
			ticketQuotaCollection.forEach(ticketQuota => {
				ticketQuota.ticketQuotaStatus.forEach(tqStatus => {
					if (!this.enableVisualTicketQuotaToggle) {
						return
					}
					this.enableVisualTicketQuotaToggle = (tqStatus.totalTickets === 0) ? true : false
					this.enableVisualTicketQuotaTooltipMsg = this.getErrorMsgVisualTicketQuotaToggle(ticketQuota.name, tqStatus.availableTickets, tqStatus.totalTickets)
				})
			})
		});
	}

	private toggleTicketQuotaMessageEditor() {
		this.showSpinner = true;
		// Update the visualQuotaFlag on event. Editor is toggled based on the flag
		this.eventApi.patchEventSpecificProperties(this.loadedEvent.storageId, {userSetHasVisualQuota: !this.loadedEvent.userSetHasVisualQuota})
			.subscribe(event => {
				this.showSpinner = false;
				this.store.dispatch(this.eventActions.eventLoaded(event));
				this.store.dispatch(this.eventActions.updateEventHasVisualQuotaSuccess());
			}, error => {
				this.showSpinner = false;
				this.store.dispatch(this.messageActions.displayMessage(
					'Die Kontingentänderung konnte nicht übernommen werden. Bitte versuchen Sie es erneut.', "error"));
			}
		)
	}

	private setSelectedSeatingplan(seatingplan: model.Seatingplan) {
		this.selectedSeatingplan = seatingplan
	}

	private goToVisualTicketQuota() {
		window.open(ZUUL_BACKEND + "/seatingplan/seatingplan/" + this.selectedSeatingplan.storageId + "/event/" + this.loadedEvent.storageId + "/quota/"
			+ this.selectedTicketQuotaStorageId, '_blank');
		this.checkVisualTicketQuotaChanged()
	}

	private getErrorMsgVisualTicketQuotaToggle(ticketQuotaName: string, availableTickets: number, totalTickets: number) {
		let errorMsg = ""
		if (totalTickets != 0) {
			if (availableTickets == 0) {
				errorMsg = "Für das Kontingent '" + ticketQuotaName + "' gibt es verkaufte Karten."
			} else {
				errorMsg = "Für das Kontingent '" + ticketQuotaName + "' gibt es Kontingentmeldungen."
			}
		}
		return errorMsg
	}

	private checkVisualTicketQuotaChanged() {
		window.addEventListener('storage', (event) => {
			if (event.key === "updateVisualTicketQuota" && event.newValue === "true") {
				this.store.dispatch(this.ticketQuotaActions.reloadTicketQuota(this.selectedTicketQuotaStorageId))
			}
		})
	}

	private loadBookingOffices() {
		return this.merchantApi.loadBookingOfficesForUser();
	}
}



// WEBPACK FOOTER //
// ./src/app/components/event-components/ticket-quota-collection/ticket-quota-collection.component.ts